"use client";

import React, { useState, useEffect, useCallback } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import type { ChaletItem } from "@/types/refiners";

interface ChaletSearchCheckboxListProps {
  items: ChaletItem[];
  onChange: (selectedIds: string[]) => void;
}

const ChaletSearchCheckboxList: React.FC<ChaletSearchCheckboxListProps> = ({
  items,
  onChange,
}) => {
  const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>({});

  // Initialize checkedItems when items change
  useEffect(() => {
    if (items?.length) {
      const initialCheckedState = items.reduce((acc, item) => {
        acc[item.id] = true;
        return acc;
      }, {} as Record<string, boolean>);
      setCheckedItems(initialCheckedState);
    }
  }, [items]);

  const handleCheckboxChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, id: string) => {
      const selectedCount = Object.values(checkedItems).filter(Boolean).length;
      // Prevent unchecking the last selected item
      if (selectedCount === 1 && !event.target.checked) return;
      setCheckedItems((prev) => ({
        ...prev,
        [id]: event.target.checked,
      }));
    },
    [checkedItems]
  );

  useEffect(() => {
    if (items) {
      const selectedIds = Object.keys(checkedItems).filter(
        (key) => checkedItems[key]
      );
      onChange(selectedIds);
    }
  }, [checkedItems, onChange, items]);
  // }, [checkedItems, items, onChange]);

  return (
    <FormGroup>
      <div className="refiner-heading">Resorts</div>
      {items && items.length > 0 ? (
        items.map((item) => {
          const selectedCount =
            Object.values(checkedItems).filter(Boolean).length;
          const isLastSelected = selectedCount === 1 && checkedItems[item.id];

          return (
            <FormControlLabel
              key={item.id}
              control={
                <Checkbox
                  checked={checkedItems[item.id] ?? false}
                  onChange={(event) => handleCheckboxChange(event, item.id)}
                  disabled={isLastSelected}
                />
              }
              label={
                <span style={isLastSelected ? { color: "grey" } : {}}>
                  {item.name}
                </span>
              }
            />
          );
        })
      ) : (
        <div>No items to display.</div>
      )}
    </FormGroup>
  );
};

export default ChaletSearchCheckboxList;
